/**
 * _maskaDirective.js
 *
 * Compatibility wrapper for maska v2.
 * In maska v1, the mask pattern was passed as the directive value: v-maska="'## / ## / ####'"
 * In maska v2, the directive value is a reactive binder object and the mask goes on data-maska.
 *
 * This wrapper allows keeping the v1 template syntax (v-maska="pattern") by intercepting the
 * value, setting data-maska on the native input element, then delegating to the real vMaska.
 */
import { vMaska } from 'maska';

export const maskaDirective = (el, binding) => {
  const input = el instanceof HTMLInputElement ? el : el.querySelector('input');
  if (!input) return;

  if (typeof binding.value === 'string') {
    input.setAttribute('data-maska', binding.value);
    vMaska(el, { ...binding, value: undefined });
  } else if (binding.value === null || binding.value === undefined) {
    input.removeAttribute('data-maska');
    vMaska(el, { ...binding, value: undefined });
  } else {
    // binding.value is an object (reactive binder) — pass through as-is
    vMaska(el, binding);
  }
};
